import { __assign, __awaiter, __generator, __read } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Box from "@mui/material/Box";
import prettier from "prettier/standalone";
import parserBabel from 'prettier/parser-babel';
import parserTs from 'prettier/parser-typescript';
import parserMarkdown from 'prettier/parser-markdown';
import { Typography, Color, GuideBox, Button } from "../..";
var combinePadding = function (padding, paddingX, paddingY) {
    if (typeof padding === "number")
        padding = "".concat(padding * 8, "px");
    if (typeof paddingX === "number")
        paddingX = "".concat(paddingX * 8, "px");
    if (typeof paddingY === "number")
        paddingY = "".concat(paddingY * 8, "px");
    if (padding !== undefined)
        return padding;
    if (paddingX !== undefined && paddingY !== undefined)
        return "".concat(paddingY, " ").concat(paddingX);
    if (paddingX !== undefined)
        return "0.5rem ".concat(paddingX);
    if (paddingY !== undefined)
        return "".concat(paddingY, " 0.5rem");
    return "0.5rem";
};
var getParserName = function (language) {
    switch (language) {
        case "js":
        case "javascript":
            return "babel";
        case "ts":
        case "typescript":
            return "typescript";
        case "json":
            return "json";
        case "markdown":
            return "markdown";
        default:
            return "babel";
    }
};
function CodeBlock(props) {
    var _this = this;
    var _a = __read(React.useState(false), 2), copySuccess = _a[0], setCopySuccess = _a[1];
    React.useEffect(function () {
        var timer = setTimeout(function () {
            setCopySuccess(false);
        }, 1500);
        return function () { return clearTimeout(timer); };
    }, [copySuccess]);
    var _b = __read(React.useState(props.children), 2), formattedCode = _b[0], setFormattedCode = _b[1];
    React.useEffect(function () {
        var formatCode = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                try {
                    result = prettier.format(props.children, {
                        parser: getParserName(props.language || 'js'),
                        plugins: [parserBabel, parserTs, parserMarkdown],
                        useTabs: true,
                        semi: true,
                        singleQuote: true,
                        trailingComma: "all",
                        jsxSingleQuote: true,
                        jsxBracketSameLine: true,
                        printWidth: 120,
                    });
                    setFormattedCode(result);
                }
                catch (error) {
                    console.error("Error formatting code:", error);
                }
                return [2 /*return*/];
            });
        }); };
        formatCode();
    }, [props.children, props.language]);
    function copyToClipboard() {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.clipboard.writeText(formattedCode)];
                    case 1:
                        _a.sent();
                        setCopySuccess(true);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error('Async: Could not copy text: ', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(Box, { width: props.width, children: [_jsxs(GuideBox, { show: true, fill: Color.primaryNegative.enable, width: "100%", row: true, horSpaceBetween: true, verCenter: true, padding: combinePadding(props.titlePadding, props.titlePaddingX, props.titlePaddingY), borderRadius: "".concat(props.radius, "px ").concat(props.radius, "px 0 0"), children: [_jsx(Typography, { color: Color.primaryNegative.white, variant: "h1", paddingLeft: '11px', children: props.title }), copySuccess ?
                        _jsx(Button, { variant: "text", disabled: true, children: "copied" }) :
                        _jsx(Button, { variant: "text", onClick: copyToClipboard, children: "copy" })] }), _jsx(SyntaxHighlighter, __assign({ id: props.id, showLineNumbers: true, style: vscDarkPlus, wrapLines: true, customStyle: __assign(__assign({ borderBottomRightRadius: props.radius, borderBottomLeftRadius: props.radius, fontSize: "3px", margin: 0, width: '100%' }, (props.backgroundColor !== undefined ? { backgroundColor: props.backgroundColor } : { backgroundColor: '#1E1E1E' })), { boxSizing: "border-box", padding: combinePadding(props.codePadding, props.codePaddingX, props.codePaddingY) }) }, props, { children: formattedCode }))] }));
}
export default CodeBlock;
